import { loadable } from "../../../../../components/loadable";
import type { SlideMobileAssetChartProps } from "./SlideMobileAssetChart";

export default loadable<SlideMobileAssetChartProps>(() => import(/* webpackChunkName: "SlideMobileAssetChart" */ './SlideMobileAssetChart'));
